// Dark Matter (G-79): a dark orb with a glowing violet rim and a swirl — unseen matter that bends
// what is around it — instead of a gem emoji (16e feedback).
import { formatNumber } from '../../labels';

export function DarkMatterIcon({ className = 'size-4' }: { className?: string }) {
  return (
    <svg
      data-icon="dark-matter"
      viewBox="0 0 24 24"
      aria-hidden
      className={`inline-block shrink-0 align-[-0.15em] text-dark-matter ${className}`}
    >
      <circle cx="12" cy="12" r="10.5" fill="none" stroke="currentColor" strokeOpacity="0.3" />
      <circle cx="12" cy="12" r="7.5" fill="#0b0614" stroke="currentColor" strokeWidth="1.75" />
      <path
        d="M12 8.25a3.75 3.75 0 1 1-3.55 4.95M12 10.5a1.5 1.5 0 1 0 1.5 1.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <circle cx="20.2" cy="6.2" r="0.9" fill="currentColor" />
      <circle cx="3.6" cy="17.4" r="0.7" fill="currentColor" fillOpacity="0.7" />
    </svg>
  );
}

/** "6 ◉" on screen, "6 Dark Matter" for screen readers and text matching. */
export function DarkMatterAmount({ value }: { value: number }) {
  return (
    <span className="inline-flex items-center gap-1">
      {formatNumber(value)}
      <DarkMatterIcon />
      <span className="sr-only"> Dark Matter</span>
    </span>
  );
}
